module.exports = __webpack_public_path__ + "static/home-adjustable-base-2-b1dceabd42b66bc4707b98b848433c90.mp4";